import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useRelationTypeValueList } from "Hooks/Options/useRelationTypeValueList";
import type { RelationType } from "Infrastructure/Api/Api";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
  disabled?: boolean;
  allowedRelations?: ReadonlyArray<RelationType>;
};

export const RelationTypeDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  allowedRelations,
  disabled,
}: Props<T, V>) => {
  const codeList = useRelationTypeValueList({
    allowedRelations,
  });

  return (
    <Dropdown
      codeList={codeList}
      name={name}
      control={control}
      label={label}
      disabled={disabled}
    />
  );
};
